import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { ApiCallPriority, apiPOST } from "../../common/api/apiCallsService";
import { transformUpdateApiItem, type UpdatePackageEntryItem } from "~/Cart/api/UpdatePackageEntry";
import { registerCallProcessor, scheduleCall } from "~/Cart/api/CartService";
import { naiveTrackCartContents } from "~/feature/Analytics/ga/abandonment";
import { getCurrentBrowserTimezone } from "~/utils/dateUtils";

export function sendDelete(item: UpdatePackageEntryItem) {
  return sendBulkDelete([item]);
}

const bulkDeleteApiUrl = resolveApiUrl("/cart/delete/bulk");
export function sendBulkDelete(items: UpdatePackageEntryItem[]) {
  return scheduleCall("delete", { items });
}

registerCallProcessor({
  type: "delete",
  canBeExecuted: (ongoingCalls) => {
    const areCallsOngoing = ongoingCalls.length > 0;
    return !areCallsOngoing;
  },
  execute: async ({ items }: { items: UpdatePackageEntryItem[] }) => {
    const body = JSON.stringify({
      items: items.map((item) => transformUpdateApiItem(item)),
      userTimeZone: getCurrentBrowserTimezone(),
    });

    const result = await apiPOST(
      bulkDeleteApiUrl,
      {
        body,
        cache: "no-cache",
        headers: {
          dataType: "json",
          "content-type": "application/json",
          CSRFToken: getCsrfValue(),
        },
        redirect: "follow",
      },
      { priority: ApiCallPriority.HIGH, skipParallelLimit: true },
    );
    window.SCHA.updateMinicart?.();
    naiveTrackCartContents();
    return result;
  },
});
